



















import { Component, Vue, Watch } from "vue-property-decorator";
import "vuesax/dist/vuesax.css";
import "./sidebar.css";
import SidebarItem from "./sidebar-item.vue";
import { RoutesList } from "@/router";
import { Route, RouteConfig } from "vue-router";
import { vsButton, vsSideBar, vsIcon, vsDivider, vsSpacer } from "vuesax";
Vue.use(vsButton);
Vue.use(vsIcon);
Vue.use(vsDivider);
Vue.use(vsSpacer);
Vue.use(vsSideBar);
@Component({
  components: { SidebarItem }
})
export default class Sidebar extends Vue {
  menuItems = RoutesList.getRoutes();
  get isMobile() {
    return this.$store.state.isMobile;
  }
  get sidebarActive() {
    return this.$store.state.sidebarActive;
  }
  set sidebarActive(value: boolean) {
    this.$store.commit("setSidebarActive", value);
  }
  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newVal: any) {
    if (this.isMobile) {
      this.$store.commit("setSidebarActive", false);
    }
  }
}
